/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';
import { PluginSidebarMoreMenuItem, PluginSidebar } from '@wordpress/edit-site';
import { registerPlugin } from '@wordpress/plugins';
import { applyFilters } from '@wordpress/hooks';

/**
 * Inner dependencies.
 */
import { GutenifyLogo as icon } from '../components/Icons';
import './color-palette';

const GutenifyGlobalOptions = ( props ) => (
	<>
		{ /* <PluginMoreMenuItem
			icon={ image }
			onClick={ () => {
				alert( 'Button Clicked' );
			} }
		>
			More Menu Item
		</PluginMoreMenuItem> */ }
		<PluginSidebarMoreMenuItem target="gutenify-global-options-sidebar">
			{ __( 'Gutenify Global Options' ) }
		</PluginSidebarMoreMenuItem>
		<PluginSidebar name="gutenify-global-options-sidebar" title={ ( 'Gutenify Global Options' ) } icon={ icon }>
			{ applyFilters( 'gutenify--global-options--sidebar', [], props ) }
		</PluginSidebar>
	</>
);

registerPlugin( 'gutenify-global-options', {
	icon,
	render: GutenifyGlobalOptions,
} );
